import React, {useState, useEffect} from "react";
import Header from "../Components/Header";
 import { useNavigate } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import axios from "axios";
import { ReactSession } from 'react-client-session';
ReactSession.setStoreType("localStorage");


 function WaChat() {
    const userId=ReactSession.get("welbeingId");
    const navigate=useNavigate();
    const queryParameters = new URLSearchParams(window.location.search);
    const id = queryParameters.get("id");
    const [input, setinput]=useState([]);
    const [error, setError] = useState("");
    const [chat, setchat] = useState([]);


    if(userId  <= 0 ){
      navigate('/login');
   }


    const handleChange =(e) =>{
     const name= e.target.name;
     const value =e.target.value;
     setinput(values=>({...values, [name]:value}))

    }

    const handleSubmit = async(e) =>{
       e.preventDefault();

         const formdata ={
            cus:id,
            message:input.message
         }

       console.log(formdata);

       console.log(input);

       try{
        const response = await axios.post('https://projects.sninfoserv.com/welb-api/whatsapp/message/', formdata)
        console.log(response.data);
          if(response.data.status==="success"){
            
            fetch();
            }else{
               console.error(response.data.error?.message);
            }
       }catch (err){
            setError(err.message);
       }
    }


    const fetch = async() =>{

        const formData = new FormData();
        formData.append('key1', id);
     

        console.log(formData.id);
      

       try{
        const response = await axios.post('https://projects.sninfoserv.com/welb-api/whatsapp/chat/', formData)
        console.log(response.data);

        if(response.data.status==="success"){
            
             setchat(response.data.data);
            }else{
               console.error(response.data.error?.message);
        }
        
       }catch (err){
            setError(err.message);
       }
    }

    useEffect(()=>{
       fetch();

    }, []);

  return (
    <>
      
        <Header/>
        <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
        
        
           <div class="body-wrapper">
              <div class="container-fluid">
      <div class="row my-4">
        <div class="col-lg-8 col-md-8 mb-md-0 mb-4 table-container">
          <div class="card">
            <div class="card-header pb-0">
              <div class="row">
                <div class="col-lg-6 col-7">
                  <h6>Chat Box</h6>
                  <p class="text-sm mb-0">
                   
                   {id}</p>
                </div>
               
              </div>
            </div>
            <div class="card-body px-0 pb-2">
              <div class="table-responsive">
                <div class="card-body">
                <table class="table align-items-center mb-0 datatable">
                  <tbody id="your-section-id"> 
                    

                   
                    {chat?.map((chat, index) => (
                      <tr key={index}> 
                        {chat.type === "outgoing" ? (
                          <>
                            <td></td>
                            <td className="align-right text-right text-sm" style={{ wordWrap: "break-word", textAlign: "right" }}>
                              <span className="text-xl ">{chat.msg}</span><br /><small style={{ fontSize: "10px" }}>{chat.ind_time}</small>
                            </td>
                          </>
                        ) : (
                          <>
                            <td className="align-middle text-left text-sm" style={{ wordWrap: "break-word", width: "50%" }}>
                              <span className="text-xl  " style={{ right: "5px" }}>{chat.msg}</span><br /><small style={{ fontSize: "10px" }}>{chat.ind_time}</small>
                            </td>
                            <td></td>
                          </>
                        )}
                      </tr>
                    ))}


                    
					</tbody>
                </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-4 col-md-4 mb-md-0 mb-4">
          <div class="card">
            <div class="card-header pb-0">
              <div class="row">
                <div class="col-lg-6 col-7">
                  <h6>Send Message</h6>
                  <p class="text-sm mb-0">
                   
                    
                  </p>
                </div>
               
              </div>
            </div>
            <div class="card-body px-0 pb-2">
              <div class="card-body">
                <form onSubmit={handleSubmit}>
                    
                    <div class="mb-3">
                        <textarea rows="11" class="form-control" name="message" placeholder="Enter your mesages here..." id="inputField2" value={input.message} onChange={handleChange}></textarea>
                    </div>
                    <div class="text-center">
                        <button type="submit" class="btn btn-success w-100 py-8 mb-4 mt-2 rounded-2" onclick="submitData()">Send</button>
                        
               
                  </div>
                </form>
              </div>
              </div>
            </div>
          </div>
        </div>
       
      </div>
        
             
            </div>
        </div>
        </>
  )
}
export default WaChat;
